module.exports = __webpack_public_path__ + "static/media/info.9dfda571.png";